import { render, staticRenderFns } from "./PollQuestionCreateEditModal.vue?vue&type=template&id=48267492&"
import script from "./PollQuestionCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./PollQuestionCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports